import { useState } from "react";
import { motion } from "framer-motion";
import { CREATORS } from "@/data/site";
import { MaskedLines, SectionTag } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const Creators = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      data-testid="creators"
      className="relative border-t border-[#1f1f1f] bg-[#0d0d0d] py-20 md:py-32"
    >
      <div className="mx-auto max-w-[1700px] px-5 md:px-10">
        <SectionTag num="02 / CREDITS">PEOPLE I'VE EDITED FOR</SectionTag>

        <MaskedLines
          lines={["EDITED FOR PEOPLE", "WHO HAVE SOMETHING", "TO SAY."]}
          className="max-w-4xl font-display text-3xl font-black uppercase leading-[0.9] tracking-[-0.04em] text-[#e5e5e5] md:text-[3.6vw]"
          testId="creators-headline"
        />

        <div className="mt-14 md:mt-20">
          {CREATORS.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewport}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              data-testid={`creator-${i}`}
              data-cursor="view"
              className="group relative flex items-center justify-between gap-6 border-t border-[#1f1f1f] py-7 md:py-10"
            >
              <span className="label shrink-0 text-[#7a7a7a]">0{i + 1}</span>
              <h3
                className="flex-1 font-display text-[7.8vw] font-black uppercase leading-none tracking-[-0.045em] transition-all duration-500 md:text-[5.1vw]"
                style={{
                  color: active === i ? "#d4ff00" : "#e5e5e5",
                  transform: active === i ? "translateX(14px)" : "none",
                }}
              >
                {c.name}
              </h3>
              <span
                className="hidden shrink-0 label text-[#7a7a7a] transition-opacity duration-400 md:block"
                style={{ opacity: active === i ? 1 : 0 }}
              >
                {c.role}
              </span>
            </motion.div>
          ))}
          <div className="border-t border-[#1f1f1f]" />
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <p className="max-w-2xl text-sm leading-relaxed text-[#a3a3a3] md:text-base">
              Creator work is a different job to brand work. The personality is
              the asset — pacing, retention and visual identity exist to protect
              it, not to perform over it.
            </p>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#7a7a7a]">
              Names listed as people whose material I've edited. No affiliation,
              endorsement or representation implied.
            </p>
          </div>
          <div className="lg:col-span-5">
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {["Podcast cuts", "Short-form", "Motion design", "Pacing", "Visual identity", "Consistency"].map(
                (s) => (
                  <li
                    key={s}
                    className="border-b border-[#1f1f1f] pb-2 label text-[#a3a3a3]"
                  >
                    {s}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
